import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import Header from '../components/Header/Header';
import './DashboardPage.css';

const DashboardPage = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const { currentLanguage } = useSelector((state) => state.language);
  
  // إذا لم يكن المستخدم مسجلاً، يتم توجيهه للصفحة الرئيسية
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  
  const policies = [
    { id: 1, type: 'Car Insurance', number: 'POL-2024-001', status: 'Active', expiry: '2024-12-31' },
    { id: 2, type: 'Medical Insurance', number: 'POL-2024-002', status: 'Active', expiry: '2024-11-30' },
    { id: 3, type: 'Travel Insurance', number: 'POL-2024-003', status: 'Expired', expiry: '2024-09-15' },
  ];
  
  const quickActions = [
    { id: 1, icon: '📄', label: { en: 'New Policy', ar: 'وثيقة جديدة' } },
    { id: 2, icon: '🔄', label: { en: 'Renew Policy', ar: 'تجديد وثيقة' } },
    { id: 3, icon: '💰', label: { en: 'Make Payment', ar: 'دفع' } },
    { id: 4, icon: '📋', label: { en: 'Claims', ar: 'مطالبات' } },
  ];
  
  return (
    <div className="dashboard-page">
      <Header />
      
      <div className="dashboard-container">
        <motion.div 
          className="welcome-section"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1>
            {currentLanguage === 'en' 
              ? `Welcome back, ${user?.name || 'User'}!` 
              : `مرحباً بعودتك، ${user?.name || 'مستخدم'}!`}
          </h1>
          <p>
            {currentLanguage === 'en' 
              ? 'Your insurance dashboard' 
              : 'لوحة تحكم التأمين الخاصة بك'}
          </p>
        </motion.div>
        
        <div className="dashboard-grid">
          <motion.div 
            className="dashboard-card policies-card"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h2>{currentLanguage === 'en' ? 'Your Policies' : 'وثائقك'}</h2>
            <div className="policies-list">
              {policies.map((policy) => (
                <div key={policy.id} className="policy-item">
                  <div className="policy-info">
                    <h4>{policy.type}</h4>
                    <p>{policy.number}</p>
                  </div>
                  <div className="policy-status">
                    <span className={`status-badge ${policy.status.toLowerCase()}`}>
                      {policy.status}
                    </span>
                    <p className="expiry-date">
                      {currentLanguage === 'en' ? 'Expires:' : 'تنتهي:'} {policy.expiry}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="dashboard-card quick-actions-card"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <h2>{currentLanguage === 'en' ? 'Quick Actions' : 'إجراءات سريعة'}</h2>
            <div className="actions-grid">
              {quickActions.map((action) => (
                <motion.button 
                  key={action.id}
                  className="action-button"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span className="action-icon">{action.icon}</span>
                  <span className="action-label">{action.label[currentLanguage]}</span>
                </motion.button>
              ))}
            </div>
          </motion.div>
          
          <motion.div 
            className="dashboard-card stats-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <h2>{currentLanguage === 'en' ? 'Insurance Stats' : 'إحصائيات التأمين'}</h2>
            <div className="stats-grid">
              <div className="stat">
                <h3>3</h3>
                <p>{currentLanguage === 'en' ? 'Total Policies' : 'إجمالي الوثائق'}</p>
              </div>
              <div className="stat">
                <h3>2</h3>
                <p>{currentLanguage === 'en' ? 'Active' : 'نشطة'}</p>
              </div>
              <div className="stat">
                <h3>1</h3>
                <p>{currentLanguage === 'en' ? 'Needs Renewal' : 'تحتاج تجديد'}</p>
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            className="dashboard-card support-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.8 }}
          >
            <h2>{currentLanguage === 'en' ? 'Need Help?' : 'تحتاج مساعدة؟'}</h2>
            <div className="support-content">
              <p>📞 +218 21 123 4567</p>
              <p>✉️ support@sanad-insurance.ly</p>
              <p>🕒 24/7 Support Available</p>
              <motion.button 
                className="support-button"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {currentLanguage === 'en' ? 'Contact Support' : 'اتصل بالدعم'}
              </motion.button>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;